import NewsContent from "../Component/News/NewsContent";

const News = () => {
    return (
        <div>
            <NewsContent />
        </div>
    )
}

export default News;